import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isUserLogin } from "../../../features/persist/persistSlice";
import { ssoLogin } from "../../../services/apiService";
import {
  persistSocketAccessToken,
  syncSocketConnection,
} from "../../../services/socketAuth";
import { socket } from "../../../socket/client";

// SSO entry point. The frontend lands here at /verify-token?token=<jwt>.
// Calls the backend with credentials so httpOnly cookies are set by the browser,
// then dispatches isUserLogin(true) and navigates to /trade — all without a full
// page reload, keeping Redux state intact.
const VerifyToken = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = (searchParams.get("token") || "").trim();

    if (!token) {
      navigate("/auth/login", { replace: true });
      return;
    }

    ssoLogin(token)
      .then((res) => {
        if (res.ok) {
          persistSocketAccessToken(token);
          dispatch(isUserLogin(true));
          syncSocketConnection(socket);
          navigate("/trade", { replace: true });
        } else {
          navigate("/auth/login", { replace: true });
        }
      })
      .catch(() => navigate("/auth/login", { replace: true }));
  }, [searchParams, navigate, dispatch]);

  return null;
};

export default VerifyToken;
